import { useState } from 'react';
import { useRouter } from 'next/router';

import './CommunityGroup.scss';
import Transition from '../../Transition/Transition.jsx';
import CommunityTopicList from '../CommunityTopicList/CommunityTopicList.jsx';
import CommunityGroupDropdown from '../CommunityGroupDropdown/CommunityGroupDropdown.jsx';
import CommunityNewTopicPopupContent from '../../redesign/PopupContent/CommunityNewTopicPopupContent/CommunityNewTopicPopupContent.jsx';

export default function CommunityGroup({
  group,
  addTopic,
  groupList,
  userLeaveGroup
}) {
  const [newTopicPopup, showNewTopicPopup] = useState(false);

  return (
    <div className="componentWrap">
      <div className="communityGroup">
        <CommunityGroupDropdown
          currentGroup={group}
          list={groupList.filter(({ xuid }) => xuid !== group.xuid)}
        />
        <CommunityTopicList
          group={group}
          list={group.topics}
          userLeaveGroup={userLeaveGroup}
        />

        <div className="communityGroup-button-wrap">
          <button
            onClick={() => showNewTopicPopup(true)}
            className="community-button"
          >
            Nieuw onderwerp
          </button>
        </div>
      </div>

      <Transition on={newTopicPopup}>
        <div className="communityTopicList-filter-popup">
          <CommunityNewTopicPopupContent
            addTopic={addTopic}
            groupXuid={group.xuid}
            onClose={() => showNewTopicPopup(false)}
          />
        </div>
      </Transition>
    </div>
  );
}
